import footerLinkApi from "../api/footer-link-api";

const add = async (payload) => {
    const resp = await footerLinkApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await footerLinkApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await footerLinkApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await footerLinkApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const saveDisplay = async (payload) => {
    const resp = await footerLinkApi.saveDisplay(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const getDisplay = async (layer) => {
    const resp = await footerLinkApi.getDisplay(layer);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const footerLinkService = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
};

export default footerLinkService;